import { RootState } from '../store';
import { APP_SETTINGS_SLICE_KEY } from './app-settings.constants';

export const selectAppRegion = (state: RootState) =>
  state[APP_SETTINGS_SLICE_KEY].region;

export const selectAppTheme = (state: RootState) =>
  state[APP_SETTINGS_SLICE_KEY].theme;
